module.exports = __webpack_public_path__ + "static/media/idme-icon-dark.d83bea2e.svg";